import { useContext } from "react";
import { ParseDTScript, } from "../../../../../functions/ParseDTScript.js";
export const useContentDt = (text, ctx) => {
    const context = useContext(ctx);
    if (text === undefined || text === null)
        return undefined;
    return ParseDTScript(text, context);
};
